import { useQueryClient } from 'react-query';
import { queryKeys } from '../fax-queries';

export const useInvalidateFaxSearchContacts = () => {
  const queryClient = useQueryClient();
  return ({ query, locationId, limit }: { query?: string; locationId?: string; limit?: number } = {}) => {
    const keys = [
      ...queryKeys.base,
      'search',
      'contacts',
      {
        ...(query ? { query } : {}),
        ...(locationId ? { locationId } : {}),
        ...(limit ? { limit } : {}),
      },
    ];
    queryClient.invalidateQueries(keys);
  };
};
